import { CheckmarkSquare04Icon } from "@hugeicons-pro/core-stroke-rounded";
import { Section } from "views/applications-id-report/components/Section";
import { SectionIcon } from "../components/SectionIcon";
import { DeclarationsList } from "../components/DeclarationsList";
import { Declarations } from "../types";

export const DeclarationsSlice = ({
  declarations
}: {
  declarations: Declarations;
}) => (
  <Section
    sectionTitle="Declarations"
    icon={<SectionIcon icon={CheckmarkSquare04Icon} />}
  >
    <DeclarationsList declarations={declarations} />
  </Section>
);
